import React from "react"
import { GovernyInfo, NewsData } from "../../../../lib/types";
import { NEWS_DETAIL } from "../../../../lib/enums";
import { getNewsDetailValue } from "../../../../lib/commonFunctions";
import DetailBuildingDamage from "./DetailBuildingDamage";
import GovernorateInfoLink from "../../../Common/GovernorateInfoLink";

interface IProps {
  sender: GovernyInfo;
  target: GovernyInfo;
  spell: NewsData;
  opponent?: boolean;
  unitNames?: any;
  peace?: boolean;
}

const NewsPersonSpell = ({
  sender,
  spell,
  target,
  opponent,
  unitNames,
  peace
}: IProps) => (
  <div className="text-item" style={{ fontWeight: "normal", borderBottom: "1px solid #242424", borderTop: "none" }}>
    <GovernorateInfoLink govId={sender.id} name={sender.name} raceName={sender.race.name} />&nbsp;
    {spell.spellPositive
      ? <i className="icon icon-kouzlo-poz positive middle"/>
      : <i className={`icon icon-kouzlo-neg middle ${(!opponent && !spell.success)
      || (opponent && spell.success) ? "positive" : "negative"}`}/>
    }
    &nbsp;<GovernorateInfoLink govId={target.id} name={target.name} raceName={target.race.name} />
    <div><strong className="white">{spell.spell && spell.spell.name}</strong></div>

    {spell.overflownSpell
      ? <span className="grey"> - overflown spell</span>
      : <div style={{ paddingTop: "7px", paddingBottom: "7px" }}>
        {spell.details[NEWS_DETAIL.CivilLoses]
        && <div>
          Civilians killed: <em>{getNewsDetailValue(spell, NEWS_DETAIL.CivilLoses)}</em>
        </div>
        }
        {spell.details[NEWS_DETAIL.DefenceE1Loses]
          && <div>
          Army units killed:&nbsp;
          {unitNames[target.race.id].e1}: <em>
          {spell.details[NEWS_DETAIL.DefenceE1Loses].value}</em>
          , {unitNames[target.race.id].e2}: <em>
          {spell.details[NEWS_DETAIL.DefenceE2Loses].value}</em>
          , {unitNames[target.race.id].e3}: <em>
          {spell.details[NEWS_DETAIL.DefenceE3Loses].value}</em>
        </div>
        }
        {spell.details[NEWS_DETAIL.BuildingDamage]
        && <div>
          Building damage:<DetailBuildingDamage
          buildingDamage={spell.details[NEWS_DETAIL.BuildingDamage].value}
        />
        </div>}
        {spell.effectDescription && spell.effectDescription.length
        && <div>
          Effect: {spell.effectDescription}
        </div>}
        {spell.details[NEWS_DETAIL.EmpoweredSpell]
        && Number.parseInt(spell.details[NEWS_DETAIL.EmpoweredSpell].value, 10) > 1
        && <div>
          Empowered spell
        </div>}
      </div>
    }
    {(!spell.spellPositive || spell.spell?.buff) && !spell.overflownSpell
    && <div style={{ display: "flex", justifyContent: "space-evenly" }}>
      {!spell.spell?.buff && <span>{opponent ? "Attack" : "Defence"} {spell.details[NEWS_DETAIL.ActionPower].value}</span>}
      {!spell.spell?.buff && spell.details[NEWS_DETAIL.GeneralExpGain]
      && <span>XP +{spell.details[NEWS_DETAIL.GeneralExpGain].value}</span>}
      {spell.spell?.buff
      && <span>XP +{peace ? "25" : spell.details[NEWS_DETAIL.GeneralExpGain] && spell.details[NEWS_DETAIL.GeneralExpGain].value}</span>}
    </div>
    }
  </div>
)

export default NewsPersonSpell;
